import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import getStyleQuery from '../../utils/tools/getStyleQuery';
import CarLabelsSkeleton from '../car-detail-view-toolbar/skeleton';
import SmallDataItemSkeleton from '../car-details-grid/small-data-item/skeleton';
import CarPriceGridSkeleton from '../car-price-grid/skeleton';

export default function CarTileGridSkeleton() {
    return (
        <Box sx={{ [getStyleQuery()]: { backgroundColor: 'background.paper', border: (theme) => `1px solid ${theme?.palette?.divider}`, borderRadius: 2, overflow: 'hidden', width: '100%' } }}>
            <Skeleton variant="rounded" sx={{ [getStyleQuery()]: { paddingTop: 'calc(100% / 4 * 3)' } }} />
            <Stack gap={1.5} divider={<Divider orientation="horizontal" flexItem sx={{ borderStyle: 'dashed', mx: -3 }} />}>
                <Box sx={{ px: 3, pt: 1.5 }}>
                    <Skeleton variant="text" sx={{ [getStyleQuery()]: { typography: 'caption', width: 0.5 } }} />
                    <Skeleton variant="text" sx={{ [getStyleQuery()]: { typography: 'h6' } }} />
                    <CarLabelsSkeleton />
                </Box>
                <Box sx={{ display: 'grid', columnGap: 2, rowGap: 1, gridTemplateColumns: 'repeat(2, 1fr)', px: 3 }}>
                    <SmallDataItemSkeleton />
                    <SmallDataItemSkeleton />
                    <SmallDataItemSkeleton />
                    <SmallDataItemSkeleton />
                    <SmallDataItemSkeleton />
                    <SmallDataItemSkeleton />
                </Box>
                <Box sx={{ display: 'grid', columnGap: 2, rowGap: 1, gridTemplateColumns: 'repeat(2, 1fr)', px: 3 }}>
                    <SmallDataItemSkeleton />
                    <SmallDataItemSkeleton />
                    <SmallDataItemSkeleton />
                </Box>
                <Box sx={{ px: 3, pb: 1.5 }}>
                    <CarPriceGridSkeleton />
                </Box>
            </Stack>
        </Box>
    );
}
